









































import Vue from "vue";
import ApiService from "../services/ApiService";
export default Vue.extend({
  data() {
    return {
      list: [],
      loading: true,
    };
  },
  methods: {
    changeStatus: function(id, status){
      const payload = {id:id, status: status};
      // alert(e);
      ApiService.sadminApi.changeFeedbackStatus(payload);
    }
  },
  mounted() {
    ApiService.sadminApi.getFeedbacks().then((response) => {
      this.list = response.data.data.reverse();
      this.loading = false;
    });
  },
});
